import React from 'react';
import { useNavigate } from 'react-router-dom';
import GenericEntityList from '../../components/Common/GenericEntityList';

const BotManagement: React.FC = () => {
  const navigate = useNavigate();

  const handleCreateBot = () => {
    navigate('/bots/create');
  };

  return (
    <GenericEntityList
      entityType="bot"
      detailsRoute="/bots"
      onCreateClick={handleCreateBot}
      createButtonLabel="Add Bot"
      showCreateButton={true}
      showExportButton={true}
    />
  );
};

export default BotManagement;

